import React from "react";
import Select, { Options } from "react-select";
import { ErrorMessage } from "formik";

type Option = {
  label: string;
  value: string;
};

type Props = {
  label?: string;
  required?: boolean;
  name: string;
  numberName: string;
  disabled?: boolean;
  options: Options<Option | any>;
  valueSelect: string;
  valueNumber: string;
  placeholder?: string;
  onSelectChange: (selectedOption: Option | any) => void;
  onNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
onNumberBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;

};

const ATMTextFieldWithSwitch: React.FC<Props> = ({
  label = "",
  required = false,
    disabled = false,
  name,
  numberName,
  options,
  valueSelect,
  valueNumber,
  placeholder = "",
  onSelectChange,
  onNumberChange,
  onNumberBlur,
  ...rest
}) => {
  // const { setFieldValue } = useFormikContext<any>();

  return (
    <div className="relative">
        {label && (
        <label
          className={`text-slate-700 font-medium text-sm ${
            disabled && "opacity-70"
          } `}
        >
        
          {label} {required && <span className="text-red-500"> * </span>}
        </label>
      )}
      <div className="flex w-full px-2 text-slate-700 border border-slate-400 outline-stone-400 rounded  focus:border-4 ">
        {/* Select Selector */}
        <div className="w-fit">
          <Select
            name={name}
            options={options}
            value={valueSelect}
            onChange={(option: any) => onSelectChange(option)}
            isSearchable
            classNamePrefix="react-select"
            menuPlacement="bottom"
            menuPosition="absolute"
            menuPortalTarget={
              typeof window !== "undefined" ? document.body : null
            }
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            className="text-slate-700"
            styles={{
              control: (base) => ({
                ...base,
                border: "none",
                boxShadow: "none",
                backgroundColor: "transparent",
                minHeight: "40px",
                height: "100%",
              }),
              valueContainer: (base) => ({
                ...base,
                padding: "0 8px",
              }),
              menu: (base) => ({
                ...base,
                width: "140px",
                zIndex: 9999,
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
          />
        </div>

        {/* Divider */}
        <div className="h-6 w-px bg-slate-400 my-auto"></div>

        {/* Phone Number Field */}
        <div className="flex-1">
          <input
            name={numberName}
            value={valueNumber}
            onChange={(e) => {
              onNumberChange(e);
            }}
            placeholder={placeholder}
            onBlur={onNumberBlur}
            className="px-2 py-2 outline-none text-sm w-full placeholder-[#ADADAD] text-slate-700 bg-white"
            {...rest}
          />
        </div>
      </div>

      {/* Error messages */}
      <div className="font-poppins absolute text-[14px] text-start mt-0 text-red-500">
        {name && <ErrorMessage name={name} component="div" />}
        {numberName && <ErrorMessage name={numberName} component="div" />}
      </div>
    </div>
  );
};

export default ATMTextFieldWithSwitch;
